import { render, staticRenderFns } from "./contact-number.vue?vue&type=template&id=41f20ce0&scoped=true&"
import script from "./contact-number.vue?vue&type=script&lang=js&"
export * from "./contact-number.vue?vue&type=script&lang=js&"
import style0 from "./contact-number.vue?vue&type=style&index=0&id=41f20ce0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f20ce0",
  null
  
)

export default component.exports